import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../../../../global/helpers/notification_delegate';
import {
  FeedbackSuggestedPlanModel,
  IFeedbackSuggestedPlanModel
} from '../../../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { AdvisorBlockedSuggestionsQuery } from '../../queries/blocked_suggestions_query';

class AdvisorBlockedSuggestions {
  constructor(
    private ngAPStudentDetailsQuery: IQuery,
    private createEmptySuggestedPlanCommand: ICommand,
    private $state: ng.ui.IStateService,
    private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
    private loadPlanFeedbackCommand: ICommand,
    private ngAPNotificationDelegate: INotificationDelegate,
    private performActionOnBlockedSuggestionsCommand: ICommand,
    private ngAPAdvisorBlockedSuggestionsQuery: AdvisorBlockedSuggestionsQuery
  ) {}
  private openDiscardDialog: boolean = false;

  sendApplicableSuggestions() {
    const suggestionIds = _4.uniq(
      _4.map(this.ngAPAdvisorBlockedSuggestionsQuery.result.acceptableSuggestions, 'resolution')
    );
    return this.performActionOnBlockedSuggestionsCommand(
      this.ngFeedbackSuggestedPlanModel.read().id,
      suggestionIds,
      'ACCEPT'
    ).then(() => {
      this.$state.go('ap-advisor.plan.edit.default', {}, { reload: true });
    });
  }

  discardPlans() {
    this.openDiscardDialog = true;
  }
}

angular.module('capability-ng-academic-planner').component('advisorBlockedSuggestions', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/components/blocked_suggestions/blocked_suggestions.html',
  controller: AdvisorBlockedSuggestions
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/components/blocked_suggestions/blocked_suggestions.ts